import React, { FunctionComponent } from "react";

interface RoadMapIconProps {
    className?: string;
}

const RoadMapIcon: FunctionComponent<RoadMapIconProps> = (
    props: RoadMapIconProps
) => {
    return (
        <div className={props.className}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7309 3.05651C17.8963 3.14261 18 3.31356 18 3.5V13.5C18 13.6756 17.9079 13.8384 17.7572 13.9287L12.7572 16.9287C12.604 17.0207 12.4134 17.0239 12.2572 16.9371L7.74616 14.431C7.58395 14.3354 7.41042 14.3367 7.25749 14.4286L7.24282 14.4371L2.74282 16.9371C2.58796 17.0231 2.39913 17.0208 2.24644 16.9309C2.09375 16.8411 2 16.6772 2 16.5V7C2 6.83684 2.07961 6.68395 2.21327 6.59039L7.21327 3.09039C7.38543 2.96987 7.61457 2.96987 7.78673 3.09039L12.5 6.38967L17.2133 3.09039C17.366 2.98347 17.5655 2.97041 17.7309 3.05651ZM3 7.26033V15.6502L6.75049 13.5666C6.83139 13.5187 6.91486 13.4792 7 13.448V4.46033L3 7.26033ZM8.24782 13.5657L12.0036 15.6523L12.0001 7.26041L8 4.46033V13.4491C8.08477 13.4801 8.16769 13.519 8.24782 13.5657ZM13.0036 15.6147L17 13.2169V4.46033L13.0001 7.26025L13.0036 15.6147Z" fill="#242424" />
            </svg>
        </div>
    );
};

export default RoadMapIcon;
